<template>
    <div v-if="isAdmin" id="ritual-bloc-management">
        <as-container gutters="0">
            <div class="grid grid-nogutter mb-3">
                <div class="flex w-100">
                    <as-title :title="$t('rituals.bloc_list.title')" :size="1"></as-title>
                    <div class="ml-auto">
                        <Button style="width: 200px" :label="$t('rituals.bloc_list.new_bloc_button_label')" class="button-default"
                            @click="showModalBlocForm" />
                    </div> 
                </div>
            </div>
            <ProgressBar v-if="isBlocLoading" mode="indeterminate" style="height: 6px" class="mb-3" />
            <bloc-list v-else :blocs="blocs" @onRowClick="editBloc" @onDelete="onShowDeleteBlocModal" />
        </as-container>
    </div>
    <as-modal :isVisible="showBlocForm" class="reduced-form-modal">
        <bloc-form @onClose="closeModalBlocForm" @onSubmit="saveBloc" :isSending="isSending" :bloc="currentBloc" />
    </as-modal>
    <as-confirm-modal :isVisible="showDeleteBlocModal" :modalMessage="$t('confirm_modal.delete_message')"
        @onConfirm="deleteBloc" @onCancel="deleteBlocCancel" />
</template>
<script>
import localeChangeDetectionMixin from "../../mixins/localeChangeDetectionMixins";
import roleMixins from "../../mixins/roleMixins";

import { mapGetters } from "vuex";

import AsTitle from "@/components/Elements/AsTitle.vue";
import AsContainer from "@/components/Containers/AsContainer.vue";
import AsModal from "@/components/Modals/AsModal.vue";
import AsConfirmModal from "@/components/Modals/AsConfirmModal.vue";

import BlocList from "@/components/Ritual/BlocList.vue";
import BlocForm from "@/components/Ritual/BlocForm.vue";

import Button from "primevue/button";
import ProgressBar from "primevue/progressbar";

import { getBlocs, saveBloc, deleteBloc } from "../../services/blocServiceApi";
import apiEventTypes from "../../constantes/apiEventTypes";


export default {
    name: "BlocManagement",
    components: {
        AsTitle,
        AsContainer,
        AsModal,
        AsConfirmModal,
        BlocList,
        BlocForm,
        Button,
        ProgressBar,
    },
    data() {
        return {
            isBlocLoading: true,
            isSending: false,
            showBlocForm: false,
            currentBloc: { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] },
            blocs: [],
            blocToDeleteId: undefined,
            showDeleteBlocModal: false,
        };
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    mixins: [localeChangeDetectionMixin, roleMixins],
    beforeMount() {
        if (!this.isAdmin) {
            this.$router.push("/")
        } else {
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            this._fetchBlocs()
        },
        showModalBlocForm() {
            this.currentBloc = { id: 0, libelle: '', sujets: [{ id: 0, libelle: '' }] }
            this.showBlocForm = true
        },
        closeModalBlocForm() {
            this.showBlocForm = false
        },
        onShowDeleteBlocModal(blocId) {
            this.blocToDeleteId = blocId;
            this.showDeleteBlocModal = true;
        },
        deleteBlocCancel() {
            this.blocToDeleteId = undefined;
            this.showDeleteBlocModal = false;
        },

        async editBloc(bloc) {
            this.currentBloc = bloc
            this.showBlocForm = true
        },
        async saveBloc(data) {
            this.isSending = true;
            const savedBloc = await saveBloc(data)
            this.isSending = false
            this.showBlocForm = false
            if (savedBloc) {
                const indexOf = this.blocs.findIndex(e => e.id === savedBloc.id)
                indexOf >= 0 ? this.blocs.splice(indexOf, 1, savedBloc) : this.blocs.push(savedBloc)
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_title"),
                            message: this.$t("popup_messages.success_created_message"),
                        },
                    })
                );
            } else {
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_ERROR, {
                        detail: {
                            title: this.$t("popup_messages.default_error_title"),
                            message: this.$t("popup_messages.default_error_message"),
                        },
                    })
                );
            }
        },
        async deleteBloc() {
            if (!this.blocToDeleteId) { return }
            const result = await deleteBloc(this.blocToDeleteId);
            if (result) {
                const newList = [...this.blocs];
                const indexOf = newList.findIndex((e) => e.id === this.blocToDeleteId);
                newList.splice(indexOf, 1);
                this.blocs = newList;
                this.deleteBlocCancel()
                document.dispatchEvent(
                    new CustomEvent(apiEventTypes.API_SUCCESS, {
                        detail: {
                            title: this.$t("popup_messages.success_delete_title"),
                            message: this.$t("popup_messages.success_delete_message"),
                        },
                    })
                );
            }
        },
        async _fetchBlocs() {
            this.isBlocLoading = true
            this.blocs = await getBlocs()
            this.isBlocLoading = false
        },
    },
};
</script>

<style lang="scss">
#ritual-bloc-management {
    .p-datatable .p-datatable-tbody>tr>td {
        padding: 0.5rem 1rem !important;
    }
}
</style>
